import * as React from 'react';
import { useState } from 'react';
import { ISuggestion, IRoom } from './types';
import { formatDate } from '../utils/dateHelper';
import { stringifyParams } from './helpers';
import Button from './Button';
import LoadingIcon from '../Shared/LoadingIcon';
import t from './locales';

interface IProps {
  label: string;
  keyword: string;
  selectedSuggestion: ISuggestion;
  selectedDateList: Date[];
  selectedRooms: IRoom[];
}

const YadoSubmitButton: React.FC<IProps> = (props) => {
  const { label, keyword, selectedSuggestion, selectedDateList, selectedRooms } = props;
  const [isLoading, setLoading] = useState<boolean>(false);
  const checkin_date = formatDate(selectedDateList[0]);
  const checkout_date = formatDate(selectedDateList.length <= 1 ? null : selectedDateList[selectedDateList.length - 1]);
  const params = { checkin_date, checkout_date, rooms: selectedRooms };
  const path = ['/snow'];

  if (selectedSuggestion) {
    const { id } = selectedSuggestion;
    params['q'] = selectedSuggestion;
    switch (selectedSuggestion.type) {
      case 'yado':
        path.push(`/accommodations/${id}`);
        break;
      case 'resort':
        path.push(`/stay/resorts/${id}`);
        break;
      case 'prefecture':
        path.push(`/stay/prefectures/${id}`);
        break;
      case 'area':
        path.push(`/stay/areas/${id}`);
        break;
      default:
    }
  } else if (keyword) {
    path.push('/stay/keywords');
    params['q'] = { type: 'keyword', id: null, label: keyword }
  }

  let isActive = true;
  if (path.length <= 1) { isActive = false; }
  if (selectedRooms == null || selectedRooms.length === 0) { isActive = false; }

  const fullPath = [path.join(''), '?', stringifyParams(params)].join('');

  function handleClick() {
    if (!isActive) {
      alert(t.yadoSearchFormAlert());
      return;
    }
    setLoading(true);
    window.location.href = fullPath;
  }

  return (
    <Button type="submit" onClick={handleClick} disabled={isLoading}>
      {isLoading ? <LoadingIcon /> : label}
    </Button>
  );
}

export default YadoSubmitButton;
